
var intervalBfShow = setInterval(waitBfShow, 500);
function waitBfShow() {
  d = new Date();
  if(document.getElementsByClassName('product-form').length>0 && ((d.getDate() == 27 && d.getMonth() == 10 && d.getFullYear()==2024 && d.getHours()<17) || (d.getDate() <= 27 && d.getMonth() == 10 && d.getFullYear()==2024))) {
    bfShow();
    clearInterval(intervalBfShow);
  }
}


function bfEmailValidate() {
	return document.getElementById('bfFormEmail').value.toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
}
function bfChangeEmail(withNotice) {
	//console.log(bfEmailValidate());
	
	bfFormEmail = document.getElementsByClassName('bfFormEmail')[0];
	bfEmailError = document.getElementsByClassName('bfEmailError')[0];
	
	if(bfEmailValidate() == null) {
		bfFormEmail.className = 'bfFormEmail error';
		if(withNotice == true) {
			bfEmailError.style.display = 'block';
		}
		setTimeout(function(){
			bfEmailError.style.display = 'none';
		}, 5000);
		return false;
	}
	bfFormEmail.className = 'bfFormEmail success';
	bfEmailError.style.display = 'none';
		
}
function bfRequest() {
    var xmlhttp = new XMLHttpRequest();
	
	if(bfEmailValidate() == null) {
		bfRequestError();
		return false;
	}
	
	bfFormEmail = document.getElementsByClassName('bfFormEmail')[0];
	bfEmailError = document.getElementsByClassName('bfEmailError')[0];
	bfSuccess = document.getElementsByClassName('bfSuccess')[0];
	bfError = document.getElementsByClassName('bfError')[0];
	bfSubmitForm = document.getElementsByClassName('bfSubmitForm')[0];
	
	bfFormEmail.readOnly = true;
	bfFormEmail.className = 'bfFormEmail success';
	bfEmailError.style.display = 'none';
	bfSuccess.style.display = 'none';
	bfError.style.display = 'none';
	bfSubmitForm.disabled = 'true';
	bfSubmitForm.innerHTML = 'Even geduld...';
	

    xmlhttp.onreadystatechange = function() {
        if (xmlhttp.readyState == XMLHttpRequest.DONE) {
           if (xmlhttp.status == 200) {
               console.log(xmlhttp.responseText);
			   bfRequestSuccess();
           }
           else if (xmlhttp.status == 400) {
               bfRequestError();
           }
           else {
               bfRequestError();
           }
        }
    };

    xmlhttp.open("GET", "https://ma.ricomoda.com/bfRegister.php?email=" + document.getElementById('bfFormEmail').value + "&url=" + encodeURI(window.location.href), true);
    xmlhttp.send();
}
function bfRequestSuccess() {
	
	bfFormEmail = document.getElementsByClassName('bfFormEmail')[0];
	bfEmailError = document.getElementsByClassName('bfEmailError')[0];
	bfSuccess = document.getElementsByClassName('bfSuccess')[0];
	bfError = document.getElementsByClassName('bfError')[0];
	bfSubmitForm = document.getElementsByClassName('bfSubmitForm')[0];
	bfConsentMessage = document.getElementsByClassName('bfConsentMessage')[0];
	
	
	bfSuccess.style.display = 'block';
	bfError.style.display = 'none';
	bfFormEmail.style.display = 'none';
	bfEmailError.style.display = 'none';
	bfSubmitForm.style.display = 'none';
	bfConsentMessage.style.display = 'none';
	setTimeout(function(){
		bfSuccess.style.display = 'none';
	}, 5000);
}
function bfRequestError() {
	
	bfSuccess = document.getElementsByClassName('bfSuccess')[0];
	bfError = document.getElementsByClassName('bfError')[0];
	bfSubmitForm = document.getElementsByClassName('bfSubmitForm')[0];
	
	bfSubmitForm.disabled = 'true';
	bfSubmitForm.innerHTML = 'Nu aanvragen';
	bfFormEmail.readOnly = false;
	
	bfSuccess.style.display = 'none';
	bfError.style.display = 'block';
	setTimeout(function(){
		bfError.style.display = 'none';
	}, 5000);
}


			
			
function bfShow() {
	if(document.getElementsByClassName('product-form').length>0 && window.location.href.indexOf('/products/')>0 && document.getElementsByClassName('bfContainer').length==0) {
		
		var vendorLink = document.querySelector('.vendor-link a');
		var productTitle = document.querySelector('.product-title')
		if(typeof(vendorLink) != 'undefined' && vendorLink != null) {
			var vendorLinkHref = decodeURI(vendorLink.href);
			var productTitleText = productTitle.innerHTML.toLowerCase();
			
			if(vendorLinkHref.indexOf('/dsquared') >= 0 || vendorLinkHref.indexOf('/diadora-heritage') >= 0 || vendorLinkHref.indexOf('/finamore') >= 0 || vendorLinkHref.indexOf('/polo-ralph-lauren') >= 0) {
				var isDiscountable = true;
			} else if((vendorLinkHref.indexOf('/drôle-de-monsieur') >= 0 || vendorLinkHref.indexOf('/drole-de-monsieur') >= 0) && productTitleText.indexOf('muts') == -1 && productTitleText.indexOf('pet') == -1 && productTitleText.indexOf('sok') == -1) {
				var isDiscountable = true;
			} else if(vendorLinkHref.indexOf('/daily-paper') >= 0 && productTitleText.indexOf('muts') == -1 && productTitleText.indexOf('pet') == -1 && productTitleText.indexOf('sok') == -1 && productTitleText.indexOf('ebucket') == -1 && productTitleText.indexOf('tas') == -1 && productTitleText.indexOf('shopper') == -1 && productTitleText.indexOf('waistbag') == -1) {
				var isDiscountable = true;
			} else if(vendorLinkHref.indexOf('/k-way') >= 0 && productTitleText.indexOf('zwembroek') == -1) {
				isDiscountable = true;
			} else if(vendorLinkHref.indexOf('/new-amsterdam') >= 0 && productTitleText.indexOf('muts') == -1 && productTitleText.indexOf('pet') == -1 && productTitleText.indexOf('tag') == -1 && productTitleText.indexOf('bag') == -1) {
				var isDiscountable = true;
			} else if(vendorLinkHref.indexOf('/filling-pieces') >= 0 && productTitleText.indexOf('sneaker') >= 0) {
				var isDiscountable = true;
			} else if(window.location.href.indexOf('/products/mason-sneakers-massif-hi-scalata-brown-09103') >= 0 || window.location.href.indexOf('/products/massif-hi-montagna-black') >= 0 || window.location.href.indexOf('/products/torino-sofisticato-brown-7b') >= 0 || window.location.href.indexOf('/products/venice-movimento-taupe-13b') >= 0 || window.location.href.indexOf('/products/tia-sofisticato-taupe-2g') >= 0) {
				var isDiscountable = true;
			} else {
				var isDiscountable = false;
			}
			
		}
		
		
		if(isDiscountable == true) {
		    btnForm = document.getElementsByClassName('product-form')[0];
			
		    var bfContainer = document.createElement("div");
		    bfContainer.className = 'bfContainer';
		    var bfTitle = document.createElement("div");
		    bfTitle.className = 'bfTitle';
		    bfTitle.innerHTML = 'Nu al profiteren van onze Black Friday korting?';
		    var bfButton = document.createElement("button");
		    bfButton.className = 'bfButton';
		    bfButton.innerHTML = 'Ontvang nu je code';
			var bfForm = document.createElement("form");
		    bfForm.className = 'bfForm';
			bfForm.style.display = 'none';
			var bfFormEmail = document.createElement("input");
		    bfFormEmail.className = 'bfFormEmail';
			bfFormEmail.id = 'bfFormEmail';
			bfFormEmail.type = 'email';
			bfFormEmail.required = 'true';
		    bfFormEmail.placeholder = 'Jouw e-mailadres';
			var bfEmailError = document.createElement("div");
		    bfEmailError.className = 'bfAlertError bfEmailError';
			bfEmailError.style.display = 'none';
		    bfEmailError.innerHTML = '<strong>Let op</strong> Dit is geen geldig e-mailadres';
		    var bfSubmitForm = document.createElement("button");
		    bfSubmitForm.className = 'bfSubmitForm';
			bfSubmitForm.type = 'button';
		    bfSubmitForm.innerHTML = 'Nu aanvragen';
			var bfConsentMessage = document.createElement("div");
		    bfConsentMessage.className = 'bfConsentMessage';
		    bfConsentMessage.innerHTML = '<strong>Let op</strong> Je meldt je hierbij aan voor de Black Friday korting en onze reguliere Rico Moda nieuwsbrief';
			var bfSuccess = document.createElement("div");
		    bfSuccess.className = 'bfAlertSuccess bfSuccess';
			bfSuccess.style.display = 'none';
		    bfSuccess.innerHTML = '<strong>Gelukt</strong> Je krijgt snel een mailtje van ons.';
			var bfError = document.createElement("div");
		    bfError.className = 'bfAlertError bfError';
			bfError.style.display = 'none';
		    bfError.innerHTML = '<strong>Mislukt</strong> Probeer je het opnieuw?';
		    var bfStyle = document.createElement("style");
		    bfStyle.innerText = '.bfTitle { font-size: calc(var(--font-heading-scale)* 1.25rem); font-weight: var(--font-body-medium-weight, 500); text-transform: uppercase; text-align: center; margin-bottom: 25px; } .bfButton { background: #000; color: #fff; border: none; border-radius: 50px; padding: 17px; width: 100%; text-align: center; font-size: .875rem; font-weight: var(--font-body-bold-weight, 600); text-transform: uppercase; } input[type=email].bfFormEmail { border: 1px solid #ccc; background: #fff; border-radius: 50px !important; width: 100%; line-height: 1em; padding: 17px; color: #000; } input[type=email].bfFormEmail.error { border-color: #ff9999; } input[type=email].bfFormEmail.success { border-color: #88cc88; } .bfFormEmail::placeholder { color: #aaa !important; text-style: italic !important; } .bfSubmitForm { background: #000; color: #fff; border: none; border-radius: 50px; padding: 17px; width: 100%; text-align: center; font-size: .875rem; font-weight: var(--font-body-bold-weight, 600); text-transform: uppercase; } .bfAlertError { border: 1px solid #ff9999; background: #ffcccc; padding: 3px; color: #000; font-size: .875em; border-radius: 5px; padding: 7px 12px; margin: 15px 0 15px 0; } .bfAlertSuccess { border: 1px solid #88cc88; background: #ccffcc; padding: 3px; color: #000;  font-size: .875em; border-radius: 5px; padding: 7px 12px; margin: 15px 0 15px 0; } .bfConsentMessage { font-size: .875em; border-radius: 5px; margin: 10px 0 5px 0; } ';

			
			
			bfButton.addEventListener("click", function (e) {
				bfForm.style.display = 'block';
				bfTitle.style.display = 'none';
				bfButton.style.display = 'none';
			});
			bfFormEmail.addEventListener("keyup", function (e) {
				bfChangeEmail(false);
			});
			bfFormEmail.addEventListener("change", function (e) {
				bfChangeEmail(true);
			});
			bfSubmitForm.addEventListener("click", function (e) {
				bfRequest();
			});
			
			
			
			bfForm.appendChild(bfFormEmail);
			bfForm.appendChild(bfEmailError);
			bfForm.appendChild(bfSubmitForm);
			bfForm.appendChild(bfConsentMessage);
			bfForm.appendChild(bfSuccess);
			bfForm.appendChild(bfError);
			bfContainer.appendChild(bfTitle);
			bfContainer.appendChild(bfButton);
			bfContainer.appendChild(bfForm);
			bfContainer.appendChild(bfStyle);
			btnForm.parentNode.insertBefore(bfContainer, btnForm);
		}
	}
}